import React from "react";
import Aux from "../../../../hoc/Auxiliary";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {normalizePathItem} from "../../../BreadCrumb/Breadcrumb";
import {STUDY_TEAM_SPACE_PATH} from "../../../../api/static-data/Configurations";
import {updateProperty} from "../../../../api/utils/conditions-utils";
import {canExportData} from "../../../../api/authorization/rules";
import ExportButton from "../../../DataCollectionDetails/BodyTemplate/ExportButton/ExportButton";
import {convert_dd_mm_yyyy_to_Date} from "../../../../api/utils/DateFormatter";

const ActionTemplate = ({row}) => {
    const navigate = useNavigate();

    const searchQueries = () => {
        navigate(STUDY_TEAM_SPACE_PATH + '/' + normalizePathItem(row?.name) + '/queries', {
            state: {
                dataCollection: {
                    name: row.name,
                    id: row.id
                }
            }
        })
    }

    return (
        <Aux>
            <div className=" grid p-0 ">
                <div className="col m-0 flex align-items-center justify-content-center p-0 p-button-rounded-sm">
                    {updateProperty(canExportData(),
                        (<ExportButton
                            dcName={row?.name}
                            dcId={row?.id}
                            isDisplayed={true}
                            disabled={convert_dd_mm_yyyy_to_Date(row?.startFrom) >= new Date()}
                            messageOnDisable={"Will be enabled when dataCollection starts."}
                            dataCollectionType={row?.type}
                        />)
                        , null)}
                </div>
                <div className=" col p-0 m-0 flex align-items-center justify-content-center">
                    <Button icon=" pi pi-angle-right"
                            tooltip="Data collection Queries"
                            tooltipOptions={{position: 'top', showOnDisabled: true}}
                            className=" p-button-rounded-sm p-button-text"
                            onClick={searchQueries}
                            style={{height: '0.5rem', width: '1.5rem', color: '#487c84'}}
                            disabled={false}/>
                </div>
            </div>
        </Aux>
    )
}
export default ActionTemplate;
